export const SUBMIT_EXTERNAL_PRESENTER_INVOICE_BY_TOKEN = `
  mutation submitExternalPresenterInvoiceByToken(
    $token: String!
    $invoice_amount: Float!
    $file: Upload!
    $per_diem_amount: Float
    $expenses_file: Upload
    $receipt_file: Upload
    $province_id: Int!
    $topic_category_id: Int!
    $presenter_firstname: String
    $presenter_lastname: String
    $phone: String
    $bank: String
    $bank_account_type: String
    $branch_office: String
    $branch_office_number: String
    $account_holder: String
    $cbu: String
    $cuit: String
  ) {
    submitExternalPresenterInvoiceByToken(
      token: $token
      invoice_amount: $invoice_amount
      file: $file
      per_diem_amount: $per_diem_amount
      expenses_file: $expenses_file
      receipt_file: $receipt_file
      province_id: $province_id
      topic_category_id: $topic_category_id
      presenter_firstname: $presenter_firstname
      presenter_lastname: $presenter_lastname
      phone: $phone
      bank: $bank
      bank_account_type: $bank_account_type
      branch_office: $branch_office
      branch_office_number: $branch_office_number
      account_holder: $account_holder
      cbu: $cbu
      cuit: $cuit
    ) {
      __typename
      ... on BooleanResult {
        result
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const RESEND_EXTERNAL_PRESENTER_INVOICE_TOKEN = `
  mutation resendExternalPresenterInvoiceToken($meeting_id: Int!, $tenant_id: Int!) {
    resendExternalPresenterInvoiceToken(meeting_id: $meeting_id, tenant_id: $tenant_id) {
      __typename
      ... on BooleanResult {
        result
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const UPDATE_EXTERNAL_PRESENTER_INVOICE_DATA = `
  mutation updateExternalPresenterInvoiceData(
    $meeting_id: Int!
    $input: UpdateExternalPresenterInvoiceDataInput!
    $invoice_file: Upload
    $expenses_file: Upload
    $receipt_file: Upload
    $tenant_id: Int!
  ) {
    updateExternalPresenterInvoiceData(
      meeting_id: $meeting_id
      input: $input
      invoice_file: $invoice_file
      expenses_file: $expenses_file
      receipt_file: $receipt_file
      tenant_id: $tenant_id
    ) {
      __typename
      ... on ExternalPresenterInvoiceData {
        id
        status
        invoice_amount
        per_diem_amount
        load_date
        presenter_firstname
        presenter_lastname
        presenter_email
        phone
        province_id
        province_name
        topic_category_id
        topic_category_name
        bank
        bank_account_type
        branch_office
        branch_office_number
        account_holder
        cbu
        cuit
        has_invoice_file
        has_expenses_file
        has_receipt_file
        provinces {
          id
          name
        }
        topicCategories {
          id
          name
        }
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;
